import {
  useAlerts as useAlertsQuery,
  useDismissDuplicateAlert as useDismissDuplicateAlertQuery,
} from '../queries/useAlerts';

export const useAlerts = () => {
  const alertsQuery = useAlertsQuery();
  const { data: alerts } = alertsQuery;

  const hasDuplicate = !!alerts?.duplicate;
  const hasDwellTime = !!alerts?.dwellTime?.length;
  const alertCount = alerts?.duplicate ? 1 : 0;

  return {
    alerts,
    hasDuplicate,
    hasDwellTime,
    alertCount,
    ...alertsQuery,
  };
};

export const useDismissDuplicateAlert = () => {
  const { mutate, isPending, error } = useDismissDuplicateAlertQuery();
  return {
    mutate,
    isPending,
    error,
  };
};
